<template>
  <popup
    ref="popup"
    :show="show"
    :title="''"
    :footer="false"
    class="indicator-desc-popup"
    @close="close"
  >
    <div class="desc-body">
      <h3 v-if="data.name" class="desc-title">{{ data.name }}</h3>
      <div v-if="data.desc" class="desc-content">{{ data.desc }}</div>
    </div>
  </popup>
</template>

<script>
import popup from '@/components-new/popup/index.vue'

export default {
  components: {
    popup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
/* 关闭按钮置右：popup 默认在左，通过 order 调整 */
.indicator-desc-popup ::v-deep .content-header {
  .icon-outline_close {
    order: 2;
  }
  span {
    order: 0;
  }
  i:last-of-type {
    order: 1;
  }
}
.desc-body {
  display: flex;
  flex-direction: column;
  gap: 16px; /* 标题与说明间距 */
  padding-bottom: 40px;
}
.desc-title {
  font-family: DiDiSans-Pro-Bold;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  letter-spacing: 0px;
  color: #0c0c0d;
  margin: 0;
  padding: 0;
}
.desc-content {
  font-family: DiDiSans-Pro-Regular;
  font-size: 32px;
  font-weight: normal;
  line-height: 40px;
  letter-spacing: 0em;
  color: #0c0c0d;
  word-break: break-word;
  white-space: pre-line; /* pathDesc 多行文案换行展示 */
}
</style>
